import React from 'react'
import styled from 'styled-components';
import variables from 'styles/_variables.scss';

export default function Button(props) {
	let imageHtml;

	if(props.icon) {
		imageHtml = <img src={props.icon} className="icon" alt={props.alt}></img>
	}

	if(!props.color || props.color === 'red') {
		return (
			<OutlineButton onClick={props.handleClick} disabled={props.disabled} className={props.className} iconLeft={props.iconLeft}>
				{/* eslint-disable-next-line */}
				<a className="text">{props.text}</a>
				{imageHtml}
			</OutlineButton>
		)
	} else if (props.color === 'blue') {
		return (
			<OutlineButtonBlue onClick={props.handleClick} disabled={props.disabled} className={props.className} iconLeft={props.iconLeft}>
				{/* eslint-disable-next-line */}
				<a className="text">{props.text}</a>
				{imageHtml}
			</OutlineButtonBlue>
		)
	}
}

const OutlineButton = styled.button`
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	height: 40px;
	min-width: 100px;
	padding: 0px 20px;
	border-radius: 100px;
	border: solid 1px ${variables.cliffordRed};
	background-color: ${variables.white};
	text-decoration: none;
	.text {
		font-family: museo-sans;
		font-size: 11px;
		font-weight: bold;
		line-height: 1.09;
		letter-spacing: 1.5px;
		color: ${variables.cliffordRed};
	}
	.icon {
		margin: ${props => props.iconLeft ? "0 8px 0 0" : "0 0 0 8px"};
		order: ${props => props.iconLeft ? -1 : 1};
	}
	&:hover:enabled {
		cursor: pointer;
		background-color: ${variables.cliffordRed};
		.text {
			color: ${variables.white};
		}
	}
	&:active:enabled {
		cursor: pointer;
		background-color: ${variables.milanoRed};
		border: none;
		.text {
			color: ${variables.white};
		}
		&:before {
			border-color: ${variables.milanoRed};
		}
	}
	&:focus {
		background-color: ${variables.cliffordRed};
		border: none;
		.text {
			color: ${variables.white};
		}
		&:before {
			display: block;
		}
	}
	&:before {
		display: none;
		content: " ";
		position: absolute;
		top: -4px;
		left: -4px;
		right: -4px;
		bottom: -4px;
		border: 2px solid ${variables.cliffordRed};
		border-radius: 100px;
	}
	&:disabled {
		opacity: 0.5;
		background-color: ${variables.grey1};
		border: none;
		.text {
			color: ${variables.white};
		}
	}
`;

const OutlineButtonBlue = styled(OutlineButton)`
	border: solid 1px ${variables.captainBlue};
	.text {
		color: ${variables.captainBlue};
	}
	&:hover:enabled {
		background-color: ${variables.captainBlue};
		.text {
			color: ${variables.white};
		}
	}
	&:active:enabled, &:focus {
		background-color: ${variables.darkBlue};
		.text {
			color: ${variables.white};
		}
	}
	&:before {
		border: 2px solid ${variables.darkBlue};
	}
`;